module.exports = __webpack_public_path__ + "img/doll-quote.857b087f.png";